import { render, staticRenderFns } from "./RevenueTargetPerCustomerType.vue?vue&type=template&id=4212fd2b&scoped=true"
import script from "./RevenueTargetPerCustomerType.vue?vue&type=script&lang=js"
export * from "./RevenueTargetPerCustomerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4212fd2b",
  null
  
)

export default component.exports